import { render, staticRenderFns } from "./RsaPazienteValutazioneIngressoPage.vue?vue&type=template&id=6d2de7e6"
import script from "./RsaPazienteValutazioneIngressoPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteValutazioneIngressoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports